(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scratch-card"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeScratchCards = (container = document) => {
      const sections =
        container.matches &&
        container.matches('.scratch-card-section')
          ? [container]
          : container.querySelectorAll(
              '.scratch-card-section'
            );

      sections.forEach((section) => {
        if (section.dataset.initialized === 'true') {
          return;
        }

        section.dataset.initialized = 'true';

        const wrapper = section.querySelector(
          '.scratch-card-wrapper'
        );

        const canvas = section.querySelector(
          '.scratch-card-canvas'
        );

        const resetButton = section.querySelector(
          '.scratch-card-reset'
        );

        const copyButton = section.querySelector(
          '.scratch-card-code'
        );

        const status = section.querySelector(
          '.scratch-card-status'
        );

        if (!wrapper || !canvas) {
          section.classList.add('is-hidden');
          return;
        }

        const context = canvas.getContext('2d', {
          willReadFrequently: true
        });

        if (!context) {
          section.classList.add('is-hidden');
          return;
        }

        const sectionId =
          section.dataset.sectionId || 'default';

        const campaignId =
          section.dataset.campaignId || 'campaign-1';

        const storageKey =
          `shopify-scratch-card-${sectionId}-${campaignId}`;

        const revealPercentage =
          Number(section.dataset.revealPercentage) || 45;

        const closeDelay =
          Number(section.dataset.closeDelay) || 2500;

        const isShopifyEditor =
          Boolean(
            window.Shopify &&
            window.Shopify.designMode === true
          );

        let drawing = false;
        let revealed = false;
        let checkCounter = 0;
        let pixelRatio = 1;
        let closingTimeout = null;
        let fadeTimeout = null;

        /*
         * Locks the page behind the scratch-card overlay.
         */
        const lockWebsite = () => {
          document.body.classList.add(
            'scratch-card-open'
          );
        };

        /*
         * Restores normal page scrolling.
         */
        const unlockWebsite = () => {
          document.body.classList.remove(
            'scratch-card-open'
          );

          document.body.style.removeProperty(
            'overflow'
          );

          document.body.style.removeProperty(
            'touch-action'
          );

          document.documentElement.style.removeProperty(
            'overflow'
          );

          document.documentElement.style.removeProperty(
            'touch-action'
          );
        };

        /*
         * Hides the card immediately for customers who
         * have already completed this campaign.
         */
        const hideScratchScreenImmediately = () => {
          revealed = true;
          drawing = false;

          section.classList.remove(
            'is-active',
            'is-closing'
          );

          section.classList.add('is-hidden');

          unlockWebsite();
        };

        /*
         * Fades the overlay away after revealing.
         */
        const closeScratchScreen = () => {
          if (
            section.classList.contains('is-hidden') ||
            section.classList.contains('is-closing')
          ) {
            return;
          }

          section.classList.remove('is-active');
          section.classList.add('is-closing');

          fadeTimeout = window.setTimeout(() => {
            section.classList.remove('is-closing');
            section.classList.add('is-hidden');

            unlockWebsite();

            window.requestAnimationFrame(() => {
              window.scrollTo(
                window.scrollX,
                window.scrollY
              );
            });
          }, 500);
        };

        /*
         * Draws the metallic gold scratch layer.
         */
        const drawCover = (width, height) => {
          context.globalCompositeOperation =
            'source-over';

          context.globalAlpha = 1;

          context.setTransform(
            1,
            0,
            0,
            1,
            0,
            0
          );

          context.clearRect(
            0,
            0,
            canvas.width,
            canvas.height
          );

          context.setTransform(
            pixelRatio,
            0,
            0,
            pixelRatio,
            0,
            0
          );

          const gradient =
            context.createLinearGradient(
              0,
              0,
              width,
              height
            );
            gradient.addColorStop(0, '#000000');
            gradient.addColorStop(0.2, '#303030');
            gradient.addColorStop(0.45, '#0d0d0d');
            gradient.addColorStop(0.7, '#707070');
            gradient.addColorStop(1, '#000000');

          context.fillStyle = gradient;
          context.fillRect(
            0,
            0,
            width,
            height
          );

          context.globalAlpha = 0.12;

          for (
            let index = 0;
            index < 180;
            index += 1
          ) {
            const x = Math.random() * width;
            const y = Math.random() * height;
            const radius =
              Math.random() * 3 + 0.5;

            context.beginPath();

            context.arc(
              x,
              y,
              radius,
              0,
              Math.PI * 2
            );

            context.fillStyle =
              index % 2 === 0
                ? 'rgba(255,255,255,0.25)'
                : 'rgba(0,0,0,0.35)';
          }

          context.globalAlpha = 1;

          context.globalCompositeOperation =
            'destination-out';

          context.lineCap = 'round';
          context.lineJoin = 'round';
        };

        /*
         * Sizes the canvas according to the displayed
         * scratch card and redraws the cover.
         */
        const resizeCanvas = () => {
          if (revealed) {
            return;
          }

          const rect =
            wrapper.getBoundingClientRect();

          if (!rect.width || !rect.height) {
            return;
          }

          pixelRatio = Math.max(
            window.devicePixelRatio || 1,
            1
          );

          canvas.width = Math.round(
            rect.width * pixelRatio
          );

          canvas.height = Math.round(
            rect.height * pixelRatio
          );

          drawCover(
            rect.width,
            rect.height
          );
        };

        const getPosition = (event) => {
          const rect =
            canvas.getBoundingClientRect();

          return {
            x: event.clientX - rect.left,
            y: event.clientY - rect.top
          };
        };

        const revealPrize = () => {
          if (revealed) {
            return;
          }

          revealed = true;
          drawing = false;

          wrapper.classList.add('is-revealed');

          if (status) {
            status.textContent =
              'Your prize has been revealed!';
          }

          /*
           * Save the completed campaign.
           * Do not save it inside the Shopify editor.
           */
          if (!isShopifyEditor) {
            try {
              localStorage.setItem(
                storageKey,
                'revealed'
              );
            } catch (error) {
              console.warn(
                'Scratch card storage is unavailable.',
                error
              );
            }
          }

          /*
           * Keep the prize visible briefly before
           * closing the overlay.
           */
          closingTimeout = window.setTimeout(() => {
            closeScratchScreen();
          }, closeDelay);
        };

        const checkScratchedPercentage = () => {
          if (
            revealed ||
            !canvas.width ||
            !canvas.height
          ) {
            return;
          }

          const imageData = context.getImageData(
            0,
            0,
            canvas.width,
            canvas.height
          );

          const pixelData = imageData.data;

          let transparentPixels = 0;
          let sampledPixels = 0;

          /*
           * Samples every fourth pixel.
           */
          for (
            let index = 3;
            index < pixelData.length;
            index += 16
          ) {
            sampledPixels += 1;

            if (pixelData[index] < 40) {
              transparentPixels += 1;
            }
          }

          if (!sampledPixels) {
            return;
          }

          const scratchedPercentage =
            (
              transparentPixels /
              sampledPixels
            ) * 100;

          if (
            scratchedPercentage >=
            revealPercentage
          ) {
            revealPrize();
          }
        };

        const scratch = (event) => {
          if (!drawing || revealed) {
            return;
          }

          event.preventDefault();

          const position = getPosition(event);

          context.lineWidth = Math.max(
            36,
            wrapper.offsetWidth * 0.1
          );

          context.lineTo(
            position.x,
            position.y
          );

          context.stroke();

          wrapper.classList.add(
            'is-scratching'
          );

          checkCounter += 1;

          if (checkCounter % 10 === 0) {
            checkScratchedPercentage();
          }
        };

        const startScratch = (event) => {
          if (revealed) {
            return;
          }

          event.preventDefault();

          drawing = true;

          const position = getPosition(event);

          context.beginPath();

          context.moveTo(
            position.x,
            position.y
          );

          context.lineTo(
            position.x + 0.01,
            position.y + 0.01
          );

          context.stroke();

          wrapper.classList.add(
            'is-scratching'
          );

          if (
            canvas.setPointerCapture &&
            event.pointerId !== undefined
          ) {
            try {
              canvas.setPointerCapture(
                event.pointerId
              );
            } catch (error) {
              /*
               * Pointer capture is optional.
               */
            }
          }
        };

        const stopScratch = () => {
          if (!drawing || revealed) {
            return;
          }

          drawing = false;
          context.beginPath();

          checkScratchedPercentage();
        };

        const resetCard = () => {
          if (closingTimeout) {
            window.clearTimeout(
              closingTimeout
            );

            closingTimeout = null;
          }

          if (fadeTimeout) {
            window.clearTimeout(
              fadeTimeout
            );

            fadeTimeout = null;
          }

          revealed = false;
          drawing = false;
          checkCounter = 0;

          section.classList.remove(
            'is-hidden',
            'is-closing'
          );

          section.classList.add('is-active');

          wrapper.classList.remove(
            'is-revealed',
            'is-scratching'
          );

          if (status) {
            status.textContent = '';
          }

          try {
            localStorage.removeItem(
              storageKey
            );
          } catch (error) {
            console.warn(
              'Scratch card storage is unavailable.',
              error
            );
          }

          lockWebsite();

          window.requestAnimationFrame(() => {
            resizeCanvas();
          });
        };

        canvas.addEventListener(
          'pointerdown',
          startScratch
        );

        canvas.addEventListener(
          'pointermove',
          scratch
        );

        canvas.addEventListener(
          'pointerup',
          stopScratch
        );

        canvas.addEventListener(
          'pointercancel',
          stopScratch
        );

        canvas.addEventListener(
          'pointerleave',
          stopScratch
        );

        window.addEventListener('resize', () => {
          if (
            !revealed &&
            section.classList.contains(
              'is-active'
            )
          ) {
            resizeCanvas();
          }
        });

        if (resetButton) {
          resetButton.addEventListener(
            'click',
            resetCard
          );
        }

        if (copyButton) {
          copyButton.addEventListener(
            'click',
            async () => {
              const code =
                copyButton.dataset.discountCode;

              const label =
                copyButton.querySelector(
                  '.scratch-card-copy-label'
                );

              try {
                await navigator.clipboard.writeText(
                  code
                );

                if (label) {
                  const previousText =
                    label.textContent;

                  label.textContent = 'Copied!';

                  window.setTimeout(() => {
                    label.textContent =
                      previousText;
                  }, 1800);
                }
              } catch (error) {
                if (label) {
                  label.textContent =
                    `Code: ${code}`;
                }

                console.warn(
                  'Unable to copy the discount code.',
                  error
                );
              }
            }
          );
        }

        let previouslyRevealed = false;

        /*
         * The card always appears in the Shopify editor.
         * On the storefront, previously completed cards
         * remain hidden.
         */
        if (!isShopifyEditor) {
          try {
            previouslyRevealed =
              localStorage.getItem(
                storageKey
              ) === 'revealed';
          } catch (error) {
            console.warn(
              'Scratch card storage is unavailable.',
              error
            );
          }
        }

        if (
          previouslyRevealed &&
          !isShopifyEditor
        ) {
          hideScratchScreenImmediately();
          return;
        }

        section.classList.remove(
          'is-hidden',
          'is-closing'
        );

        section.classList.add('is-active');

        lockWebsite();

        /*
         * Wait for the overlay to become visible,
         * then measure and draw the canvas.
         */
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            resizeCanvas();
          });
        });
      });
    };

    const startScratchCards = () => {
      initializeScratchCards(document);
    };

    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        startScratchCards
      );
    } else {
      startScratchCards();
    }

    document.addEventListener(
      'shopify:section:load',
      (event) => {
        initializeScratchCards(event.target);
      }
    );

    document.addEventListener(
      'shopify:section:unload',
      () => {
        document.body.classList.remove(
          'scratch-card-open'
        );

        document.body.style.removeProperty(
          'overflow'
        );

        document.documentElement.style.removeProperty(
          'overflow'
        );
      }
    );

    /*
     * Safety cleanup for browser back/forward cache.
     */
    window.addEventListener('pageshow', () => {
      const activeCard =
        document.querySelector(
          '.scratch-card-section.is-active'
        );

      if (!activeCard) {
        document.body.classList.remove(
          'scratch-card-open'
        );

        document.body.style.removeProperty(
          'overflow'
        );

        document.body.style.removeProperty(
          'touch-action'
        );

        document.documentElement.style.removeProperty(
          'overflow'
        );

        document.documentElement.style.removeProperty(
          'touch-action'
        );
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
